// ===========================================
// Parent Notification Preferences Page
// ===========================================
// Allows parents to manage their multi-channel notification preferences

import { NotificationPreferencesForm } from '../../components/notifications';
import {
  NotificationType,
  notificationTypeLabels,
  notificationTypeDescriptions,
} from '../../api/notifications.api';

// ===========================================
// NOTIFICATION TYPE ORDER (Parent)
// ===========================================

// ⚠️ This array is a WHITELIST, not a sort order — a type absent from it is not
// rendered at all, so the parent can neither see nor change that preference.
const notificationTypeOrder: NotificationType[] = [
  'LESSON_REMINDER',
  'LESSON_RESCHEDULED',
  'LESSON_CANCELLED',
  'HYBRID_BOOKING_OPENED',
  'HYBRID_BOOKING_REMINDER',
  'INVOICE_CREATED',
  'PAYMENT_RECEIVED',
  'FILE_UPLOADED',
  'MESSAGE_RECEIVED',
  'ATTENDANCE_SUMMARY',
];

// ===========================================
// COMPONENT
// ===========================================

export default function NotificationPreferencesPage() {
  return (
    <NotificationPreferencesForm
      notificationTypeOrder={notificationTypeOrder}
      notificationTypeLabels={notificationTypeLabels}
      notificationTypeDescriptions={notificationTypeDescriptions}
      breadcrumbs={[
        { label: 'Parent', path: '..' },
        { label: 'Notifications' },
      ]}
    />
  );
}
